import {CustomComponentContext, CustomComponentContextType} from '@/utils/contexts/CustomComponentContext';
import {useContext, useEffect, useState} from 'react';
import {Controller} from 'react-hook-form';
import {Radio} from "alurkerja-ui";

export default function InputMakanSiangField() {
  const { setValue, control, watch } = useContext<CustomComponentContextType>(CustomComponentContext);
  const classNamesLabel = "after:content-['*'] after:text-red-400 after:text-sm font-medium";
  const [isWfo, setIsWfo] = useState(false);
  const RADIO_OPTIONS = [
    { label: 'Ya', key: 'Ya' },
    { label: 'Tidak', key: 'Tidak' },
  ];

  useEffect(() => {
    setValue('is_lunch_at_office', null);
    setValue('is_fasting', null);
    setIsWfo(watch('location') === 'WFO');
  }, [watch('location')]);

  if (isWfo) {
    return (
      <div className="flex flex-col gap-4">
        <div>
          <label className={classNamesLabel}>Apakah Makan Siang?</label>
          <Controller
            name={'is_lunch_at_office'}
            control={control}
            rules={{required: {value: isWfo, message: `Apakah Makan Siang is Required.`}}}
            render={({fieldState, field: { onChange } }) => (
              <>
                <Radio
                  listOption={RADIO_OPTIONS}
                  onChange={onChange}
                  defaultValue={watch('is_lunch_at_office')}
                />
                {fieldState.error && <p className="text-sm text-red-500">{fieldState.error.message}</p>}
              </>
            )}
          ></Controller>
        </div>
        <div>
          <label className={classNamesLabel}>Apakah Puasa?</label>
          <Controller
            name={'is_fasting'}
            control={control}
            rules={{required: {value: isWfo, message: `Apakah Puasa is Required.`}}}
            render={({fieldState, field: { onChange } }) => (
              <>
                <Radio
                  listOption={RADIO_OPTIONS}
                  onChange={onChange}
                  defaultValue={watch('is_fasting')}
                />
                {fieldState.error && <p className="text-sm text-red-500">{fieldState.error.message}</p>}
              </>
            )}
          ></Controller>
        </div>
      </div>
    );
  }

  return null;
}